module.exports = __webpack_public_path__ + "img/C-721-730.1aa2fe28.svg";